import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { colDefs, EmployeeSalaryPopUp, rowData, salaryRowData, table2ColDefs, table2Data } from "./EmployeeSalaryTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { permission } from "../../../utils/enums/ValidationMessage";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";

class EmployeeSalary extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false
            },
            urlId: 0,
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            prop: {},
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            rowData: [],
            colDefs: [],
            table2ColDefs: [],
            table2Data: [],
            employeeBasicDetails: {
                idEmployeeSalary: 0,
                updateStatus: 0,
                voucherNo: "",
                date: "",
                accSubHead: "",
                fromDate: "",
                toDate: "",
                authorisedBy: "",
                e_Date: "",
                accSubHeadId: 0,
                generalProducts: [],
                authorisedById: 0,
                employeeList: [],
                totalChequeAmt: "",
            },
            employeeSalaryDetails: {
                idEmployee: 0,
                employeeName: "",
                totalDays: "",
                workingDays: "",
                weekOffDays: "",
                basicSalary: "",
                hraAmt: "",
                convAmt: "",
                spAllow: "",
                grossSalary: "",
                pf: "",
                esic: "",
                pt: "",
                loanAmt: "",
                deductAmt: "",
                //netPayble: "",
                tds: "",
                remarks: "",
                monthlySalary: 0,
                totalChequeAmt: "",
                index: null
            },
            salaryRowData: [],
            salaryColdefs: [],
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForEmployeeBasicDetails: {
                // date: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "date"
                //         ),
                //     },
                // ],
                accSubHeadId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "account sub head"
                        ),
                    },
                ],
                // fromDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "from date"
                //         ),
                //     },
                // ],
                // toDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "to date"
                //         ),
                //     },
                // ],
                // authorisedById: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "authorised by"
                //         ),
                //     },
                // ],
            },
            validationRulesForEmployeeSalaryDetails: {
                idEmployee: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "employee"
                        ),
                    },
                ],
                totalDays: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "total days"
                        ),
                    },
                ],
                workingDays: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "working days"
                        ),
                    },
                ],
            },
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Employee Salary");
        //}
    };

    daysCalculation = (key) => {
        let data = this.state.employeeSalaryDetails
        if (key === "weekOffDays") {
            if (Number(this.state.employeeSalaryDetails.totalDays)) {
                var TotalDays = Number(data.totalDays) ? Number(data.totalDays) : 0;
                var WorkingDays = Number(data.workingDays) ? Number(data.workingDays) : 0;
                var WeekOffDays;
                WeekOffDays = (TotalDays - WorkingDays);
                data.weekOffDays = Math.round(WeekOffDays).toFixed(2);
                this.setState({ employeeSalaryDetails: data })
            }
            //} 
            // else if (key === "PTAmt_Leave") {
            //     //if (Number(this.state.employeeSalaryDetails.totalDays)) {
            //     var PF = Number(data.pf) ? 0 : Number(data.pf);
            //     var ESIC = Number(data.esic) ? 0 : Number(data.esic);
            //     var PT = Number(data.pt) ? 0 : Number(data.pt);
            //     var DeductAmt = Number(data.deductAmt) ? 0 : Number(data.deductAmt);
            //     var Gross = Number(data.grossSalary) ? 0 : Number(data.grossSalary);
            //     var TDS = Number(data.tds) ? 0 : Number(data.tds);
            //     var amt;
            //     amt = (Gross - (PF + ESIC + PT + DeductAmt + TDS));
            //     data.monthlySalary = Math.round(amt).toFixed(2); //.ToString("F2", CultureInfo.CurrentCulture);
            //     this.setState({ employeeSalaryDetails: data });
            //     //}
        } else if (key === "WorkingDays_Leave") {

            var basicSalary = Number(data.basicSalary) ? Number(data.basicSalary) : 0;
            var TotalDays = Number(data.totalDays) ? Number(data.totalDays) : 0;
            var WorkingDays = Number(data.workingDays) ? Number(data.workingDays) : 0;
            var HRA = Number(data.hraAmt) ? Number(data.hraAmt) : 0;
            var CONV = Number(data.convAmt) ? Number(data.convAmt) : 0;

            var PerDaySalary;
            PerDaySalary = (basicSalary / TotalDays) * WorkingDays;
            HRA = (HRA / TotalDays) * WorkingDays;
            CONV = (CONV / TotalDays) * WorkingDays;
            data.basicSalary = Math.round(PerDaySalary).toFixed(2);
            data.hraAmt = Math.round(HRA).toFixed(2);
            data.convAmt = Math.round(CONV).toFixed(2);

            this.setState({ employeeSalaryDetails: data }, () => {
                this.calcSalaryAmt();
                debugger;
                this.daysCalculation("weekOffDays");
                debugger;
                this.ptAmt_LeaveCalculation("PTAmt_Leave");
            });
        }
    }

    ptAmt_LeaveCalculation = (key) => {
        let data = this.state.employeeSalaryDetails
        if (key === "PTAmt_Leave") {
            var PF = Number(data.pf) ? Number(data.pf) : 0;
            var ESIC = Number(data.esic) ? Number(data.esic) : 0;
            var PT = Number(data.pt) ? Number(data.pt) : 0;
            var DeductAmt = Number(data.deductAmt) ? Number(data.deductAmt) : 0;
            var Gross = Number(data.grossSalary) ? Number(data.grossSalary) : 0;
            var TDS = Number(data.tds) ? Number(data.tds) : 0;
            var amt;
            amt = (Gross - (PF + ESIC + PT + DeductAmt + TDS));
            data.monthlySalary = Math.round(amt); //.ToString("F2", CultureInfo.CurrentCulture);
            this.setState({ employeeSalaryDetails: data });
        }
    }

    spAlloAmtCalculation = () => {
        let data = this.state.employeeSalaryDetails
        var basicSalary = Number(data.basicSalary) ? Number(data.basicSalary) : 0;
        var HRA = Number(data.hraAmt) ? Number(data.hraAmt) : 0;
        var ConvAmt = Number(data.convAmt) ? Number(data.convAmt) : 0;
        var Sp = Number(data.spAllow) ? Number(data.spAllow) : 0;
        var Gross;
        Gross = (basicSalary + HRA + ConvAmt + Sp);
        data.grossSalary = Gross;
        this.setState({ employeeSalaryDetails: data }, () => {
            this.calcSalaryAmt();
            this.ptAmt_LeaveCalculation("PTAmt_Leave");
        });
    }

    calcSalaryAmt = () => {
        //try {
        let data = this.state.employeeSalaryDetails;
        var GrossSalary;
        var GrossSalary2;

        var basicSalary = Number(data.basicSalary) ? Number(data.basicSalary) : 0;
        var HRA = Number(data.hraAmt) ? Number(data.hraAmt) : 0;
        var CONV = Number(data.convAmt) ? Number(data.convAmt) : 0;
        var SpAll = Number(data.spAllow) ? Number(data.spAllow) : 0;

        GrossSalary = Math.round(basicSalary + HRA + CONV + SpAll);
        GrossSalary2 = Math.round(basicSalary + CONV + SpAll);
        data.grossSalary = GrossSalary;
        data.monthlySalary = GrossSalary.toFixed(2);
        var PFAmt;
        var PTamt;
        PFAmt = GrossSalary2 * 12 / 100;
        data.pf = Math.round(PFAmt).toFixed(2);

        var ESICAmt;
        ESICAmt = GrossSalary * 0.75 / 100;
        data.esic = Math.round(ESICAmt).toFixed(2);

        if (GrossSalary < 6000) {
            PTamt = 0;
            data.pt = Math.round(PTamt).toFixed(2);
        }
        if (GrossSalary >= 6000 && GrossSalary <= 8999) {
            PTamt = 80;
            data.pt = Math.round(PTamt).toFixed(2);
        }
        if (GrossSalary >= 9000 && GrossSalary <= 11999) {
            PTamt = 150;
            data.pt = Math.round(PTamt).toFixed(2);
        }
        if (GrossSalary >= 12000) {
            PTamt = 200;
            data.pt = Math.round(PTamt).toFixed(2);
        }
        this.setState({ employeeSalaryDetails: data })
    }



    componentDidMount = () => {

        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getEmployeeSalaryDropdown();
            });
        } else {
            // window.location.href = "/Login";
        }
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };


    getEmployeeSalaryDropdown = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 2
        }
        this.accountTransactionServices.getEmployeeSalaryDropdown(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dropDowndata = response.responseItem.responseContent;
                let data = this.state.employeeSalaryDetails;
                data.generalProducts = dropDowndata.filter(
                    item => item.source === 'Master_GeneralProduct'
                ).filter(item => item.label?.includes('SALARY'));
                data.employeeList = dropDowndata.filter(item => item.source === 'Master_Employee');
                let voucherNo = dropDowndata.filter(item => item.source === 'EmployeeSalaryCount');
                data.voucherNo = voucherNo?.[0].value > 0 ? (voucherNo?.[0].value + 1) : (0 + 1);

                this.setState({
                    employeeBasicDetails: data
                });
            }
        });
    }

    getMasterEmployeeSelectbyIDForSalry = (id) => {
        this.accountTransactionServices.getMasterEmployeeSelectbyIDForSalry(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let value = response.responseItem.responseContent[0];
                let data = this.state.employeeSalaryDetails;

                //data.netPayble = value.balanceAmount;
                data.convAmt = Number(value.conv);
                data.esic = Number(value.esic);
                data.grossSalary = Number(value.grossSalary);
                data.hraAmt = Number(value.hra);
                data.idEmployee = Number(value.idEmployee);
                data.pf = Number(value.pfAmt);
                data.pt = Number(value.ptAmt);
                data.basicSalary = Number(value.salary);
                data.spAllow = Number(value.specialAllowance);
                data.tds = Number(value.tds);
                data.loanAmt = Number(value.balanceAmount);
                this.setState({
                    employeeSalaryDetails: data
                });
            }
        });
    }

    getTransactionEmployeeSalaryByID = (id) => {
        this.accountTransactionServices.getTransactionEmployeeSalaryByID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    //data.netPayble = value.balanceAmount;
                    let data = this.state.employeeBasicDetails;
                    data.idEmployeeSalary = res.idEmployeeSalary;
                    data.updateStatus = 1;
                    data.voucherNo = res.idEmployeeSalary;
                    data.date = res.salaryDate ? moment(res.salaryDate).format('YYYY-MM-DD') : "";
                    data.accSubHead = res.idAccountHead;
                    data.fromDate = res.fromDate ? moment(res.fromDate).format('YYYY-MM-DD') : "";
                    data.toDate = res.toDate ? moment(res.toDate).format('YYYY-MM-DD') : "";
                    data.authorisedById = res.authorisedBy;
                    data.e_Date = res.e_Date ? res.e_Date : null;
                    data.accSubHeadId = res.idAccountHead;
                    this.setState({
                        employeeBasicDetails: data,
                        isModalOpen: true
                    });
                    this.accountTransactionServices.getTransactionEmployeeSalaryDetailsByID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            let employeeSalaryDetails = this.state.employeeSalaryDetails;
                            //debugger;
                            let employeeSalaryItemList = [];
                            if (value.length > 0) {
                                value.map((x) => {
                                    //debugger;
                                    let request = {
                                        //idEmployeeSalary: y.idEmployeeSalary,
                                        idEmployee: x.idEmployee,
                                        employeeName: this.state.employeeBasicDetails.employeeList?.find(item => item.value === x.idEmployee)?.label,
                                        totalDays: x.totalDays,
                                        workingDays: x.workingDays,
                                        weekOffDays: x.weekOffDays,
                                        basicSalary: x.basicSalary,
                                        hraAmt: x.hra,
                                        convAmt: x.conve,
                                        spAllow: x.specialAll,
                                        grossSalary: x.grossSalary,
                                        pf: x.pf,
                                        esic: x.esic,
                                        pt: x.pt,
                                        loanAmt: x.balanceAmt,
                                        deductAmt: x.deductAmount,
                                        monthlySalary: x.monthSalary,
                                        tds: x.tds,
                                        remarks: x.remarks,
                                    }
                                    employeeSalaryItemList.push(request);
                                });
                                if (employeeSalaryItemList.length > 0) {
                                    const salaryColdefs = Object.keys(employeeSalaryItemList[0]).map((key) => ({
                                        field: key.includes(".") ? key.replace(/\./g, "_") : key,
                                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                                        minWidth: this.getColumnWidth(key),
                                        flex: 1,
                                        filter: true,
                                        floatingFilter: true,
                                        hide: ["idEmployee"].includes(key) ? true : false,
                                        // width: this.getPinnedWidth(key),
                                        valueGetter: (params) => params.data[key],
                                        // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                                        //   ? (params) => {
                                        //     if (!params.value) return "";
                                        //     return moment(params.value).format("DD-MM-YYYY");
                                        //   }
                                        //   : undefined,
                                        //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                                    }));
                                    this.setState({
                                        salaryRowData: employeeSalaryItemList,
                                        salaryColdefs: salaryColdefs
                                    }, () => {
                                        this.retsetEmployeeSalaryDetails();
                                    });
                                }
                                this.setState({ employeeSalaryDetails: employeeSalaryDetails });
                            }
                            //}
                            //employeeSalaryDetails = data;
                        }
                    });

                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Employee Salary",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                this.setPermissions(permissions);
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    //debugger;
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                            hide: ["idEmployeeSalary"].includes(key),
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("salaryDate") || key.includes("fromDate") || key.includes("toDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Employee Salary",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Employee Salary");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.employeeBasicDetails;
        details.idEmployeeSalary = id;
        this.setState({ employeeBasicDetails: details }, () => {
            this.getTransactionEmployeeSalaryByID(this.state.employeeBasicDetails.idEmployeeSalary);
        });
    };

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.04,
            "employeeSalaryNo": window.innerWidth * 0.08,
            "salaryDate": window.innerWidth * 0.05,
            "subHead": window.innerWidth * 0.25,
            "fromDate": window.innerWidth * 0.05,
            "toDate": window.innerWidth * 0.05,
            "bankTransferNo": window.innerWidth * 0.08,
            // table2
            "employeeName": window.innerWidth * 0.2,
            "monthSalary": window.innerWidth * 0.06,
            "deductAmount": window.innerWidth * 0.06,
            "specialAll": window.innerWidth * 0.06,
            "grossSalary": window.innerWidth * 0.08,
            "totalDays": window.innerWidth * 0.05,
            "workingDays": window.innerWidth * 0.06,
            // Popup Table
            "weekOffDays": window.innerWidth * 0.08,
            "basicSalary": window.innerWidth * 0.08,
            "hraAmt": window.innerWidth * 0.06,
            "convAmt": window.innerWidth * 0.06,
            "spAllow": window.innerWidth * 0.06,
            "pf": window.innerWidth * 0.06,
            "esic": window.innerWidth * 0.06,
            "pt": window.innerWidth * 0.06,
            "loanAmt": window.innerWidth * 0.08,
            "deductAmt": window.innerWidth * 0.08,
            "monthlySalary": window.innerWidth * 0.08,
            "tds": window.innerWidth * 0.06,
            "remarks": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.efit);
            return;
        }
        this.getTransactionEmployeeSalaryByID(event.data.idEmployeeSalary);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ isModalOpen: true, validState: validState })
    };
    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    handleChangeForEmployeeBasicDetails = (event, name) => {
        let value = event.target.value;
        let details = this.state.employeeBasicDetails;
        details[name] = value;
        this.setState({ employeeBasicDetails: details });
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.employeeSalaryDetails;
        details[name] = value;
        this.setState({ employeeSalaryDetails: details }, () => {
            if ((name === "totalDays" || name === "workingDays") && Number(value) > 0) {
                this.daysCalculation("weekOffDays");
            } else if ((name === "workingDays" || name === "pf" || name === "esic" || name === "pt" || name === "deductAmt" || name === "tds")
                && Number(value) > 0) {
                this.ptAmt_LeaveCalculation("PTAmt_Leave");
            } else if (name === "spAllow" && Number(value) > 0) {
                this.spAlloAmtCalculation();

            }
        });
    }

    handleChangeFroDropdown = (event, name) => {
        let value = event.value;
        if (name === 'idEmployee') {
            let details = this.state.employeeSalaryDetails;
            details[name] = value;
            this.setState({ employeeSalaryDetails: details }, () => {
                this.getMasterEmployeeSelectbyIDForSalry(value);
            });
        } else {
            let details = this.state.employeeBasicDetails;
            details[name] = value;
            this.setState({ employeeBasicDetails: details });
        }
    }

    handleSelectChange = (event, name) => {
        let select = event.target.value;
        let details = this.state.debitNoteDetails;
        details[name] = select;
        this.setState({ debitNoteDetails: details });
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFieldsBasicDetails();
        if (isValidAllFields) {
            if (this.state.salaryRowData.length === 0) {
                this.SwalServices.Error("Please add employee salary details.");
            } else {
                let details = this.state.employeeBasicDetails;
                let details2 = this.state.salaryRowData;
                let y = this.state.employeeSalaryDetails;
                let employeeSalaryItemList = [];
                details2.map((x) => {
                    let request = {
                        //idEmployeeSalary: y.idEmployeeSalary,
                        idEmployee: x.idEmployee,
                        basicSalary: x.basicSalary,
                        hra: x.hraAmt,
                        conve: x.convAmt,
                        specialAll: x.spAllow,
                        grossSalary: x.grossSalary,
                        pf: x.pf,
                        pt: x.pt,
                        esic: x.esic,
                        balanceAmt: x.loanAmt,
                        deductAmount: x.deductAmt,
                        monthSalary: x.monthlySalary,
                        remarks: x.remarks,
                        workingDays: x.workingDays,
                        weekOffDays: x.weekOffDays,
                        totalDays: x.totalDays,
                        tds: x.tds
                    }
                    employeeSalaryItemList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idEmployeeSalary: details.idEmployeeSalary,
                        updateStatus: details.updateStatus,
                        salaryDate: details.date,
                        idAccountHead: details.accSubHeadId,
                        fromDate: details.fromDate,
                        toDate: details.toDate,
                        referenceNo: 0,
                        authorisedBy: details.authorisedById,
                        remarks: "",
                        totalSalaryAmount: details.totalChequeAmt,
                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        employeeSalaryItemList: employeeSalaryItemList
                    }
                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.accountTransactionServices.submitEmployeeSalaryStructuredInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.employeeBasicDetails.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    if (this.state.urlId) {
                                        this.setState({ route: '/ledger-report' });
                                    } else {
                                        this.resetDetailsFields();
                                        this.setState(
                                            { isModalOpen: false },
                                            () => {
                                                this.procSelectAllRecordsSP();
                                            }
                                        );
                                    }
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        }).finally(() => {
                            this.isSubmitting = false;
                            this.setState({ isSaving: false });
                        });
                }
            }
        }
    }

    isValidAllFieldsBasicDetails = () => {
        const newValidState = isValidForm(
            this.state.employeeBasicDetails,
            this.state.validationRulesForEmployeeBasicDetails,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsSalaryDetails = () => {
        const newValidState = isValidForm(
            this.state.employeeSalaryDetails,
            this.state.validationRulesForEmployeeSalaryDetails,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let data = this.state.employeeBasicDetails;
        data.idEmployeeSalary = 0;
        data.updateStatus = 0;
        data.voucherNo = "";
        data.date = "";
        data.accSubHead = "";
        data.fromDate = "";
        data.toDate = "";
        data.authorisedBy = "";
        data.e_Date = "";
        data.accSubHeadId = 0;
        data.authorisedById = 0;
        this.setState({ employeeBasicDetails: data, salaryRowData: [], validState: validState }, () => {
            this.retsetEmployeeSalaryDetails();
        });
    }

    insertItem = (key) => {
        const isValidAllFields = this.isValidAllFieldsSalaryDetails();
        if (isValidAllFields) {
            let data = [...this.state.salaryRowData];
            let employeeSalaryDetail = this.state.employeeSalaryDetails;
            let salaryRowData = {};
            salaryRowData.idEmployee = employeeSalaryDetail.idEmployee;
            salaryRowData.employeeName = this.state.employeeBasicDetails.employeeList?.find(item => item.value === employeeSalaryDetail.idEmployee)?.label;
            salaryRowData.totalDays = employeeSalaryDetail.totalDays;
            salaryRowData.workingDays = employeeSalaryDetail.workingDays;
            salaryRowData.weekOffDays = employeeSalaryDetail.weekOffDays;
            salaryRowData.basicSalary = employeeSalaryDetail.basicSalary;
            salaryRowData.hraAmt = employeeSalaryDetail.hraAmt;
            salaryRowData.convAmt = employeeSalaryDetail.convAmt;
            salaryRowData.spAllow = employeeSalaryDetail.spAllow;
            salaryRowData.grossSalary = employeeSalaryDetail.grossSalary;
            salaryRowData.pf = employeeSalaryDetail.pf;
            salaryRowData.esic = employeeSalaryDetail.esic;
            salaryRowData.pt = employeeSalaryDetail.pt;
            salaryRowData.loanAmt = employeeSalaryDetail.loanAmt;
            salaryRowData.deductAmt = employeeSalaryDetail.deductAmt;
            salaryRowData.monthlySalary = employeeSalaryDetail.monthlySalary;
            salaryRowData.tds = employeeSalaryDetail.tds;
            salaryRowData.remarks = employeeSalaryDetail.remarks;
            //salaryRowData.monthlySalary = employeeSalaryDetail. ;
            if (employeeSalaryDetail.index !== null && employeeSalaryDetail.index >= 0) {
                data[employeeSalaryDetail.index] = salaryRowData;
            } else {
                data.push(salaryRowData);
            }
            this.setState({ salaryRowData: data }, () => {
                let data = this.state.salaryRowData;
                let employeeSalaryDetails = this.state.employeeBasicDetails
                var totalAmount = 0;
                data.map((X) => {
                    totalAmount = totalAmount + Number(X.monthlySalary);
                });
                employeeSalaryDetails.totalChequeAmt = totalAmount;

                if (data.length > 0) {
                    const salaryColdefs = Object.keys(data[0]).map((key) => ({
                        field: key.includes(".") ? key.replace(/\./g, "_") : key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        minWidth: this.getColumnWidth(key),
                        flex: 1,
                        filter: true,
                        floatingFilter: true,
                        hide: ["idEmployee"].includes(key) ? true : false,
                        // width: this.getPinnedWidth(key),
                        valueGetter: (params) => params.data[key],
                        // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                        //   ? (params) => {
                        //     if (!params.value) return "";
                        //     return moment(params.value).format("DD-MM-YYYY");
                        //   }
                        //   : undefined,
                        //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                    }));
                    this.setState({
                        employeeSalaryDetails: employeeSalaryDetails,
                        salaryColdefs: salaryColdefs
                    }, () => {
                        this.retsetEmployeeSalaryDetails();
                    });
                }
            });
        }
    }

    deleteItem = () => {
        let details = this.state.employeeSalaryDetails
        let data = [...this.state.salaryRowData];
        data.splice(details.index, 1);
        this.setState({ salaryRowData: data }, () => {
            let data = this.state.salaryRowData;
            let employeeSalaryDetails = this.state.employeeBasicDetails
            var totalAmount = 0;
            data.map((X) => {
                totalAmount = totalAmount + Number(X.monthlySalary);
            });
            employeeSalaryDetails.totalChequeAmt = totalAmount;
            this.setState({
                employeeSalaryDetails: employeeSalaryDetails,
            }, () => {
                this.retsetEmployeeSalaryDetails();
            });
        })
    }

    handleCellClickItemList = (event) => {
        let data = [...this.state.salaryRowData];
        let getSalaryData = data[event.data.key];
        let setSalaryData = this.state.employeeSalaryDetails;

        setSalaryData.totalDays = getSalaryData.totalDays;
        setSalaryData.workingDays = getSalaryData.workingDays;
        setSalaryData.weekOffDays = getSalaryData.weekOffDays;
        setSalaryData.basicSalary = getSalaryData.basicSalary;
        setSalaryData.hraAmt = getSalaryData.hraAmt;
        setSalaryData.convAmt = getSalaryData.convAmt;
        setSalaryData.spAllow = getSalaryData.spAllow;
        setSalaryData.grossSalary = getSalaryData.grossSalary;
        setSalaryData.pf = getSalaryData.pf;
        setSalaryData.esic = getSalaryData.esic;
        setSalaryData.pt = getSalaryData.pt;
        setSalaryData.loanAmt = getSalaryData.loanAmt;
        setSalaryData.deductAmt = getSalaryData.deductAmt;
        setSalaryData.monthlySalary = getSalaryData.monthlySalary;
        setSalaryData.tds = getSalaryData.tds;
        setSalaryData.remarks = getSalaryData.remarks;

        this.setState({ employeeSalaryDetails: setSalaryData });
    };

    retsetEmployeeSalaryDetails = () => {
        let employeeSalaryDetails = this.state.employeeSalaryDetails;
        //employeeSalaryDetails = {};
        //let data = {
        employeeSalaryDetails.employeeName = "";
        employeeSalaryDetails.idEmployee = 0;
        employeeSalaryDetails.totalDays = "";
        employeeSalaryDetails.workingDays = "";
        employeeSalaryDetails.weekOffDays = "";
        employeeSalaryDetails.basicSalary = "";
        employeeSalaryDetails.hraAmt = "";
        employeeSalaryDetails.convAmt = "";
        employeeSalaryDetails.spAllow = "";
        employeeSalaryDetails.grossSalary = "";
        employeeSalaryDetails.pf = "";
        employeeSalaryDetails.esic = "";
        employeeSalaryDetails.pt = "";
        employeeSalaryDetails.loanAmt = "";
        employeeSalaryDetails.deductAmt = "";
        employeeSalaryDetails.monthlySalary = "";
        employeeSalaryDetails.tds = "";
        employeeSalaryDetails.remarks = "";
        employeeSalaryDetails.monthlySalary = 0;
        employeeSalaryDetails.index = null;
        //}
        //employeeSalaryDetails = data;
        this.setState({ employeeSalaryDetails: employeeSalaryDetails })
    }

    onRowDoubleClickedForSalaryDetails = (event) => {
        let details = event.data
        let employeeSalaryDetails = this.state.employeeSalaryDetails
        employeeSalaryDetails = details
        employeeSalaryDetails.index = event.rowIndex
        this.setState({ employeeSalaryDetails: employeeSalaryDetails })

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };


    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='employee-salary'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: this.handleSave,
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <EmployeeSalaryPopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            handleChangeForEmployeeBasicDetails={this.handleChangeForEmployeeBasicDetails.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            employeeBasicDetails={this.state.employeeBasicDetails}
                            employeeSalaryDetails={this.state.employeeSalaryDetails}
                            salaryRowData={this.state.salaryRowData}
                            salaryColdefs={this.state.salaryColdefs}
                            validState={this.state.validState}
                            insertItem={this.insertItem.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            close={this.closePopup.bind(this)}
                            onRowDoubleClickedForSalaryDetails={this.onRowDoubleClickedForSalaryDetails.bind(this)}
                        // handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Employee salary</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    columnDefs={this.state.colDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady}
                                    onCellClicked={this.handleCellClick2}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default EmployeeSalary;